import { GroupByOption, StoredMetric } from "../common-tile.model";


export class MetricOrientation {
  public static readonly horizontal = 'horizontal';
  public static readonly vertical =  'vertical';
}

export class TableMetric {
  metric: StoredMetric;
}

export class StoredTableTileDefinition {
  header: string;
  groupByOptions: GroupByOption[];
  metrics: TableMetric[];
  orientation: string = MetricOrientation.horizontal; // Default to vertical
  defaultGroupBys: GroupByOption[] = [];

  constructor(
    header: string = '',
    groupByOptions: GroupByOption[] = [],
    metrics: TableMetric[] = [],
    orientation: string = MetricOrientation.horizontal, // Default to vertical
    defaultGroupBys: GroupByOption[] = []
  ) {
    this.header = header;
    this.groupByOptions = groupByOptions;
    this.metrics = metrics;
    this.orientation = orientation;
    this.defaultGroupBys = defaultGroupBys;
  }

}
